import { AfterViewInit, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { AddbrandComponent } from '../../brand/addbrand/addbrand.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddfoodsymbolComponent } from '../../foodsymbol/addfoodsymbol/addfoodsymbol.component';
import { AddgroupComponent } from '../../group/addgroup/addgroup.component';
import { AddsubgroupComponent } from '../../subgroup/addsubgroup/addsubgroup.component';
import { AdduomComponent } from '../../uom/adduom/adduom.component';
import { AddproductComponent } from '../addproduct/addproduct.component';
@Component({
  selector: 'app-productview',
  templateUrl: './productview.component.html',
  styleUrls: ['./productview.component.css']
})
export class ProductviewComponent implements OnInit {


  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isgroupaddmode: boolean = false;
  issubgroupaddmode: boolean = false;
  isuomaddmode: boolean = false;
  isbrandaddmode: boolean = false;
  isfoodsymboladdmode: boolean = false;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  errtxt: any = "";

  productvariationColl: any = [];
  productColl: any = [];
  productid: number = 0
  productBO: any = [];
  //Edit Get Values

  companyColl: any = [];
  groupColl: any = [];
  subgroupColl: any = [];
  taxColl: any = [];
  brandColl: any = [];
  uomColl: any = [];
  foodsymbolColl: any = [];
  pricetypeColl: any = [];
  //pageColl:any=[];

  productform = new FormGroup({
    productid: new FormControl(0),
    productcode: new FormControl('', Validators.required),
    productname: new FormControl('', Validators.required),
    productdesc: new FormControl(null),
    barcode: new FormControl('', Validators.required),
    groupid: new FormControl(null, Validators.required),
    subgroupid: new FormControl(null, Validators.required),
    brandid: new FormControl(null, Validators.required),
    uomid: new FormControl(null, Validators.required),
    taxid: new FormControl(null, Validators.required),
    foodsymbolid: new FormControl(null, Validators.required),
    istaxincluded: new FormControl(false),
    price1: new FormControl(null),
    cost: new FormControl(null),
    inactive: new FormControl(false),


    //price: new FormControl(null, Validators.min(1)),
    // productimage: new FormControl(null),

  });


  //set image
  image;
  strImage: any;
  picurl: string = "";
  picname: string = "";

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Product";

  issp1: boolean = false;
  issp2: boolean = false;
  issp3: boolean = false;
  issp4: boolean = false;
  issp5: boolean = false;
  issp6: boolean = false;
  issp7: boolean = false;
  issp8: boolean = false;
  issp9: boolean = false;
  issp10: boolean = false;


  sp1displayname: string = '';
  sp2displayname: string = '';
  sp3displayname: string = '';
  sp4displayname: string = '';
  sp5displayname: string = '';
  sp6displayname: string = '';
  sp7displayname: string = '';
  sp8displayname: string = '';
  sp9displayname: string = '';
  sp10displayname: string = '';


  constructor(private appService: DhukanDataService, private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, public loginService: LoginDataService,) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.productid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.productform.reset();
      this.fnInitializeProduct();

      if (this.productid > 0) {
        this.fngetProduct();
      }

      this.fngetGroup()
      this.fngetSubgroup()
      this.fngetBrand()
      this.fngetUom()
      this.fngetTax()
      this.fngetCompany()
      this.fngetFoodsymbol()
      this.fnsetTaxtype()
      this.fngetPricetype()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.productid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isgroupaddmode = this.loginService.fnCheckUserRoleAction("Group", 'CREATE')
    this.issubgroupaddmode = this.loginService.fnCheckUserRoleAction("Subgroup", 'CREATE')
    this.isuomaddmode = this.loginService.fnCheckUserRoleAction("Uom", 'CREATE')
    this.isbrandaddmode = this.loginService.fnCheckUserRoleAction("Brand", 'CREATE')
    this.isfoodsymboladdmode = this.loginService.fnCheckUserRoleAction("Foodsymbol", 'CREATE')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeProduct() {
    this.productform.setValue({
      productid: 0,
      productname: '',
      productcode: 'NEW',
      barcode: '',
      productdesc: '',
      groupid: null,
      subgroupid: null,
      brandid: null,
      uomid: null,
      taxid: null,
      istaxincluded: false,
      price1: null,
      cost: null,
      foodsymbolid: null,
      inactive: false,


    })
  }
  fngetPricetype() {
    var data = {
      'pricetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getPricetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.pricetypeColl = res.json().result;



            for (let abo of this.pricetypeColl) {
              if (abo.pricetag === 'SP1') {
                this.issp1 = true
                this.sp1displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP2') {
                this.issp2 = true
                this.sp2displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP3') {
                this.issp3 = true
                this.sp3displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP4') {
                this.issp4 = true
                this.sp4displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP5') {
                this.issp5 = true
                this.sp5displayname = abo.pricetypename
              }
              else if (abo.pricetag === 'SP6') {
                this.issp6 = true
                this.sp6displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP7') {
                this.issp7 = true
                this.sp7displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP8') {
                this.issp8 = true
                this.sp8displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP9') {
                this.issp9 = true
                this.sp9displayname = abo.pricetypename
              } else if (abo.pricetag === 'SP10') {
                this.issp10 = true
                this.sp10displayname = abo.pricetypename
              }
            }

          }

        },

        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetFoodsymbol() {
    var data = {
      'foodsymbolid': 0,
      'companyid': this.loginService.fnGetCompanyId(),

    }
    this.appService.getFoodsymbol(data)
      .subscribe(
        (res) => {
          this.foodsymbolColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetCompany() {
    var data = {
      'companyid': 0,

    }
    this.appService.getCompany(data)
      .subscribe(
        (res) => {
          this.companyColl = res.json().result;
          this.fnsetTaxtype();
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetGroup() {
    var data = {
      'groupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGroup(data)
      .subscribe(
        (res) => {
          this.groupColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetTax() {
    var data = {
      'taxid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTax(data)
      .subscribe(
        (res) => {
          this.taxColl = res.json().result;
         
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetBrand() {
    var data = {
      'brandid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getBrand(data)
      .subscribe(
        (res) => {
          this.brandColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetUom() {
    var data = {
      'uomid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getUom(data)
      .subscribe(
        (res) => {
          this.uomColl = res.json().result;
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetSubgroup() {

    if (this.productform.get('groupid').value > 0) {

      var data = {
        'groupid': this.productform.get('groupid').value,

      }
      this.appService.getSubgroup(data)
        .subscribe(
          (res) => {
            this.subgroupColl = res.json().result;

            if (this.subgroupColl.length > 0) {
              let ischeck = false;
              for (let lbo of this.subgroupColl) {
                if (lbo.subgroupid === this.productform.get('subgroupid').value) {
                  ischeck = true;
                }
              }

              if (ischeck === false) {
                this.productform.patchValue({ subgroupid: null });
              }

            }

          },
          (err) => {
            this.toastr.error('Error', err);
          })
    }
    else {
      this.subgroupColl = []
      this.productform.patchValue({ subgroupid: null });
    }

  }


  fnGroupChange() {
    let groupid = this.productform.get('groupid').value;
    if (groupid === null) {
      this.productform.patchValue({ subgroupid: null });
    }

  }




  fngetProduct() {
    var data = {
      'productid': this.productid,
      'companyid':this.loginService.fnGetCompanyId()
    }
    this.appService.getProduct(data)
      .subscribe(
        (res) => {

          this.productColl = res.json().result[0];
          this.productvariationColl = res.json().result[1];
          //console.log(this.productvariationColl)

          var editdata = this.productColl[0];
          this.productBO = editdata
          //console.log(this.productBO)
          this.fnEditMode(editdata);

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fnValidation() {

    var _ischeck = false;
    var _detailscheck = false;

    for (let row of this.productColl) {

      if (row.taxid > 0) {
        _detailscheck = true;
      }

    }
    if (!_detailscheck) {
      this.errtxt = "Select Tax Percentage"
      this.productform.controls['inactive'].setErrors({ 'notfound': true });
      _ischeck = true;
    }
  }
  fnResetValidation() {

    if (this.productform.get('inactive')) {
      this.productform.controls['inactive'].setErrors(null);
    }

  }
  //Save Btn Click
  fnSaveBtnClick() {
    try {
      this.submitted = true;
      this.successfully = false;

      this.fnResetValidation()
      //Validate
      if (this.productform.valid) {

        this.fnValidation()
        //Check
        var data = {
          'productid': this.productid,
          'productcode': this.productform.get('productcode').value,
          'productname': this.productform.get('productname').value,
          'barcode': this.productform.get('barcode').value,
          'productdesc': this.productform.get('productdesc').value,
          'groupid': this.productform.get('groupid').value,
          'subgroupid': this.productform.get('subgroupid').value,
          'brandid': this.productform.get('brandid').value,
          'uomid': this.productform.get('uomid').value,
          'taxid': this.productform.get('taxid').value,
          'istaxincluded': this.productform.get('istaxincluded').value,
          'price1': this.productform.get('price1').value,
          'cost': this.productform.get('cost').value,
          'foodsymbolid': this.productform.get('foodsymbolid').value,
          'inactive': this.productform.get('inactive').value,
          // 'price': this.productform.get('price').value,
          // 'productimage': this.strImage,
          // 'picurl': this.picurl,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckProduct(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.productform.get('productid').value > 0) {
                //Update Department
                this.fnSetProduct(data);
              }
              else {
                //Insert Department
                this.fnInsertProduct(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.productform.controls['productname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertProduct(data) {

    this.appService.fnInsertProduct(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.toastr.success('', "The new Product has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.productname);

        
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetProduct(data) {

    this.appService.fnSetProduct(data).subscribe(
      (res) => {
        if (res.json().status === 200) {
          this.toastr.success('', "The Product has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.productid, data.productname);

         
        }
      },
      (err) => {
        this.toastr.error('Error', err);
      });

  }

  fnsetTaxtype() {
    var _taxtype = '';
    for (let row of this.companyColl) {
      _taxtype = row.taxtype
    }

    this.productform.patchValue({ 'taxid': _taxtype })

  }


  // //Image Import
  // changeListener($event): void {
  //   try {
  //     this.readThis($event.target);
  //   } catch (ex) {
  //     this.fnShowErrorMsg(ex);
  //   }
  // }

  // readThis(inputValue: any): void {

  //   var file: File = inputValue.files[0];
  //   var myReader: FileReader = new FileReader();

  //   myReader.onloadend = (e) => {
  //     this.image = myReader.result;
  //     this.strImage = this.image.split(',')[1];
  //   }
  //   myReader.readAsDataURL(file);
  // }

  // removeimage() {
  //   this.image = null;
  //   this.strImage = null;
  //   this.picurl = "";
  // }

  // fnOpenFileBrowser(event: any) {

  //   event.preventDefault();

  //   let element: HTMLElement = document.getElementById('image') as HTMLElement;
  //   element.click();

  // }




  private fnEditMode(deptBO) {

    this.productform.setValue({
      productid: deptBO.productid,
      productcode: deptBO.productcode,
      productname: deptBO.productname,
      barcode: deptBO.barcode,
      productdesc: deptBO.productdesc,
      groupid: deptBO.groupid,
      subgroupid: deptBO.subgroupid,
      brandid: deptBO.brandid,
      uomid: deptBO.uomid,
      taxid: deptBO.taxid,
      istaxincluded: deptBO.istaxincluded,
      price1: deptBO.price1,
      cost: deptBO.cost,
      foodsymbolid: deptBO.foodsymbolid,
      inactive: deptBO.inactive,
      // productimage: null,

    });

    this.picurl = deptBO.picurl;

   
    this.fngetSubgroup()

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;
  }

  //Addgroup
  private fnAddGroup() {

    const modalRef = this.productFindService.open(AddgroupComponent, { size: <any>'m' });
    modalRef.componentInstance.groupColl = this.groupColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetGroup();

      if (receivedEntry > 0) {
        this.productform.patchValue({ groupid: receivedEntry })
      }
    });

  }
  //AddSubgroup
  private fnAddSubgroup() {

    const modalRef = this.productFindService.open(AddsubgroupComponent, { size: <any>'m' });
    modalRef.componentInstance.subgroupColl = this.subgroupColl
    modalRef.componentInstance.groupid = this.productform.get('groupid').value
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetSubgroup();

      if (receivedEntry > 0) {
        this.productform.patchValue({ subgroupid: receivedEntry })
      }
    });

  }
  private fnAddBrand() {

    const modalRef = this.productFindService.open(AddbrandComponent, { size: <any>'m' });
    modalRef.componentInstance.brandColl = this.brandColl

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetBrand();

      if (receivedEntry > 0) {
        this.productform.patchValue({ brandid: receivedEntry })
      }
    });

  }
  private fnAddFoodsymbol() {

    const modalRef = this.productFindService.open(AddfoodsymbolComponent, { size: <any>'m' });
    modalRef.componentInstance.foodsymbolColl = this.foodsymbolColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetFoodsymbol();

      if (receivedEntry > 0) {
        this.productform.patchValue({ foodsymbolid: receivedEntry })
      }
    });

  }
  //AddUom
  private fnAddUom() {

    const modalRef = this.productFindService.open(AdduomComponent, { size: <any>'m' });
    modalRef.componentInstance.uomColl = this.uomColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      this.fngetUom();
      if (receivedEntry > 0) {
        this.productform.patchValue({ uomid: receivedEntry })
      }


    });

  }
  fnEditProduct() {
  
    try {
    
      var deptid = this.productid
     
      const modalRef = this.productFindService.open(AddproductComponent, { size: <any>'xxl', backdrop: 'static' });
      modalRef.componentInstance.productid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetProduct();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      // this.appService.fnInsertActivity(data).subscribe(
      //   (res)=>{
      //   },
      //   (err)=>{

      //   });

    } catch {

    }
  }
  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/Product']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }






}
